<template>
  <div class="home-page">
    <van-swipe :autoplay="3000" :height="170" style="border-radius: 10px" indicator-color="white">
      <van-swipe-item v-for="(item,index) in memberArticleList" :key="index">
        <img :src="imgUrl + item.AttachUrl" alt="" style="width: 100%;max-height: 100%"
             @click="goToArticleDetail(item)">
      </van-swipe-item>
    </van-swipe>
    <div>
      <van-row>
        <van-col style="margin-right:15px;">
          <div @click="goTo('租赁')" class="a-box">
            <div class="icon-style zl">
              <svg-icon icon-class="租赁" color="#19C82A"></svg-icon>
            </div>
            <div class="text">租赁</div>
          </div>
        </van-col>
        <van-col>
          <div @click="goTo('预收')" class="a-box">
            <div class="icon-style ys">
              <svg-icon icon-class="预收" color="#008AFA"></svg-icon>
            </div>
            <div class="text">预收</div>
          </div>
        </van-col>
      </van-row>
      <van-row style="margin-top: 15px">
        <van-col style="margin-right:15px;">
          <div @click="goTo('报修')" class="a-box">
            <div class="icon-style bx">
              <svg-icon icon-class="报修" color="#EBAD00"></svg-icon>
            </div>
            <div class="text">报修</div>
          </div>
        </van-col>
        <van-col>
          <div class="a-box" @click="goTo('退租')">
            <div class="icon-style tz">
              <svg-icon icon-class="退租" color="#E73B3B"></svg-icon>
            </div>
            <div class="text">退租</div>
          </div>
        </van-col>
      </van-row>
    </div>

    <div style="margin: 10px 0;font-weight: bold">我所在寝室的有效合同</div>

    <!-- 设备信息  -->
    <equipment-info-module isRightBtn style="margin-bottom: 15px" @click="linkToEquipmentControl" :order-info="validOrder" v-if="showValidOrder"></equipment-info-module>

    <template v-if="loading">
      <div class="no-valid-order">
        <van-loading style="margin-bottom: 15px"></van-loading>
        <span>加载中...</span>
      </div>
    </template>
    <template v-else>
      <list-group
          :title="validOrder.PackageName"
          foot-left-label="有效期"
          v-if="showValidOrder">
        <template slot="top">
          <div class="special">
            <div class="special-left" :style="{ backgroundColor: validOrder.IsProxy ? '#E73B3B' : '#468AFF' }">{{validOrder.IsProxy ? '代表' : '成员'}}</div>
            <div class="special-right" :style="{ backgroundColor: '#F0FFEB' }">
              <div class="special-right-right">合同编号：{{validOrder.Code}}</div>
            </div>
          </div>
        </template>
        <template slot="content">
          <div class="item">
            <div>
              <svg-icon icon-class="租金" color="#999999"></svg-icon>
              合同租金：￥{{ validOrder.Price }}
            </div>
            <div>
              <svg-icon icon-class="押金" color="#999999"></svg-icon>
              合同押金：￥{{ validOrder.Deposit }}
            </div>
          </div>
          <div class="item">
            <svg-icon icon-class="身份" color="#999999"></svg-icon>
            代表：{{validOrder.ProxyName}}
          </div>
          <div class="addr">
            <div>
              <svg-icon icon-class="地址" color="#999999"></svg-icon>地址：
            </div>
            <div>
              <div>{{ validOrder.BizDormitoryInfo.RegionName }}</div>
              <div>{{ validOrder.BizDormitoryInfo.FullAddress }}</div>
            </div>
          </div>
        </template>
        <template slot="footLeft">
          <div class="yxq">
            <div>
              <svg-icon icon-class="合同有效期" color="#999999"></svg-icon>
            </div>
            <div>
              <div>{{ validOrder.PackageEndTimeStr ? `有效期至${validOrder.PackageEndTimeStr}` : '' }}</div>
              <div>{{validOrder.PackageMode}}</div>
            </div>
          </div>
        </template>
        <template slot="footRight">
          <div class="detail-btn" v-if="validOrder.IsProxy" @click="linkTo">查看详情</div>
        </template>
      </list-group>
      <div v-else class="no-valid-order">
        <svg-icon icon-class="暂无数据 (3)"></svg-icon>
        <span>暂无有效合同</span>
      </div>
    </template>


    <!--<button @click="cearCookie">清除cookie</button>-->
    <!--<div>-->
    <!--<span>我的设备</span>-->
    <!--<div style="width: 100%;height: 500px;background: #fff;margin-top: 10px"></div>-->
    <!--</div>-->
    <!--<button @click="cearCookie()">清 除</button>-->
  </div>
</template>

<script>
import {getWeixInfo, setWeixInfo} from '@/utils/auth'
import listGroup from "@/views/modules/listGroup.vue";
import EquipmentInfoModule from "@/views/equipmentControl/modules/equipmentInfo.vue";

export default {
  name: 'home',
  data() {
    return {
      listGroupObj: {
        head: {},
        title: '',
        foot: {}
      },
      userInfo: {},
      // userInfo: {
      //     IsRegister:true
      // },
      IsRegister: false,
      imgUrl: process.env.VUE_APP_BASE_URL,
      memberArticleList: [],
      myList: [
        {
          Name: '我的设备'
        }
      ],
      validOrder: {
        BizPackageInfo: {},
        BizDormitoryInfo: {}
      },
      showValidOrder: false,
      loading: false,
    }
  },
  components: {
    EquipmentInfoModule,
    listGroup
  },
  methods: {
    async goTo(type){
      await this.getDetailsByKey()
      if(this.userInfo.IsRegister) {
        this.$dialog.confirm({
          title: '提示',
          message: `请确认当前所在寝室：${this.userInfo.RegionName}-${this.userInfo.FullAddress}`,
          confirmButtonText: '确认',
          cancelButtonText: '去换寝'
        }).then(() => {
          let linkUrl = {}
          switch (type) {
            case '租赁': {
              linkUrl = {path: '/equipment/rent', query: {backUrl: 'home'}}
              break;
            }
            case '预收': {
              linkUrl = {path: '/advance/manage', query: {backUrl: 'home'}}
              break
            }
            case '报修': {
              linkUrl = {path: '/equipment/orderMain', query: {type: '报修',title: '报修',backUrl: 'home'}}
              break
            }
            case '退租': {
              linkUrl = {path: '/equipment/orderMain', query: {type: '退租',title: '退租',backUrl: 'home'}}
              break
            }
            default: {
              break
            }
          }
          this.$router.replace(linkUrl)
        }).catch(() => {
          this.$router.replace({path: '/userIn/userChangeRoom', query: { backUrl: 'home' }})
        })
      }else {
        this.$router.replace({path: '/bindingMobile', query: {backUrl: 'home'}})
      }
    },
    async getDetailsByKey() {
      try {
        const res = await this.$post('/BizMemberMember/DetailsByKey')
        if(res.Status === 1) {
          this.$set(this, 'userInfo', res.Data)
          setWeixInfo(JSON.stringify(res.Data))
        }
      }catch (e) {
      }
    },
    cearCookie() {
      this.$store.dispatch('FedLogOut').then(() => {
        window.location.href = 'http://180108web.turuitech.com'
      })
    },
    getMemberArticle() {
      const params = {
        Type: '首页轮播'
      }
      this.$post('/BizMemberArticle/AllList', params).then(res => {
        if (res) {
          this.memberArticleList = res.Data
        }
      })
    },
    goToArticleDetail(item) {
      this.$router.replace({path: '/article/articleDetail', query: {Id: item.Id, backUrl: 'home'}})
    },
    async getValidOrder() {
      this.loading = true
      this.showValidOrder = false
      try {
        const {Data} = await this.$post('/BizMemberParentOrder/MemberEffectiveParentOrder')
        this.validOrder = Data
        this.showValidOrder = !!Data
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    linkToEquipmentControl(data) {
      if (data.Type === '智能空调') this.$router.replace({name: 'equipmentControl', query: {backUrl: 'home'}})
    },
    linkTo() {
      this.$router.replace({name: 'orderDetails', query: {Id: this.validOrder.Id, backUrl: 'home'}})
    }
  },
  mounted() {
    this.getMemberArticle()
    this.getValidOrder()
  },
  async created() {
    await this.getDetailsByKey()
  }
}
</script>

<style lang="less" scoped>
.home-page {
  background-color: #FAFAFA;
  padding: 10px;
  padding-bottom: 60px;
  overflow-y: auto;

  a {
    width: 100%;
  }



  .detail-btn{
    width: 90px;
    text-align: center;
    background-color: #19C82A;
    color: #ffffff;
    border-radius: 45px;
    float: right;
  }
  .item {
    color: #999999;
    display: flex;
    align-items: center;
    line-height: 24px;

    > div {
      display: flex;
      align-items: center;

      &:nth-child(1) {
        margin-right: 20px;
      }
    }

    .svg-icon {
      font-size: 16px !important;
    }
  }


  .addr{
    color: #999999;
    display: flex;
    line-height: 24px;
  }

  .yxq{
    display: flex;
    >div{
      line-height: 24px;
    }
  }

  .no-valid-order {
    margin-top: 15px;
    height: 160px;
    border-radius: 8px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .svg-icon {
      font-size: 70px !important;
      margin-bottom: 10px;
    }

    color: #999999;
  }


  ::v-deep.special{
    display: flex;
    .special-left{
      width: 40px;
      flex-shrink: 0;
      border-radius: 4px;
      color: #ffffff;
      margin-right: 5px;
      font-size: 12px!important;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .special-right{
      width: 100%;
      display: flex;
      align-items: center;
      line-height: 22px;
      color: #626561;
      border-radius: 4px;
      font-size: 12px!important;
      overflow: hidden;
      .special-right-left{
        width: 80px;
        flex-shrink: 0;
        padding-left: 10px;
        color: #ffffff;
        font-size: 12px!important;
        clip-path: polygon(0% 0%, 100% 0%, 80% 100%, 0% 100%);
      }
      .special-right-right{
        width: 100%;
        font-size: 12px!important;
      }
    }
  }


  .equipment-by-dormitory{
    border-radius: 10px;
    padding: 10px;
    margin-top: 15px;
    background-color: #ffffff;
    display: flex;

    .content{
      width: 100%;
      .code{
        color: #A6A6A6;
        margin-bottom: 10px;
      }
      .name{
        margin-bottom: 8px;
        color: #3D3D3D;
      }
      .type{
        span{
          display: inline-block;
          vertical-align: top;
          margin-right: 10px;
          border-radius: 4px;
          font-size: 12px;
          padding: 2px 6px;
          color: #ffffff;
        }
      }
    }
    .link{
      width: 15px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
    }

  }


}

.van-cell {
  padding: 5px;
}

.van-row::after {
  content: none;
}

.van-row {
  margin-top: 15px;
  display: flex;
  justify-content: space-around;
}

.van-cell__value--alone {
  text-align: center;
  font-size: 16px;
  color: #49a3fe;
  margin-top: 15px;
}

.van-col {
  height: 60px;
  border-radius: 8px;
  background-color: white;
  width: 100%;
  justify-content: center;
  text-align: center;
  //box-shadow: 5px 5px 8px rgba(0,0,0,.05);

  .a-box {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 20px;

    .svg-icon {
      font-size: 20px !important;
    }

    .icon-style {
      flex-shrink: 0;
      width: 34px;
      height: 34px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      &.zl {
        background-color: #DFFFE2;
      }

      &.ys {
        background-color: #D9EAF7;
      }

      &.bx {
        background-color: #FFF5DE;
      }

      &.tz {
        background-color: #FFEFEF;
      }
    }

    .text {
      font-size: 18px;
      padding-left: 15px;
    }
  }

}


</style>
